import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import {BrowserRouter} from "react-router-dom";
import {Provider} from "react-redux";
import {store} from "./store/store";
import ThemeContext from "./context/ThemeContext";
import {
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
import "./i18n";
import {I18nextProvider} from "react-i18next";
import {disableProductionConsole} from "./utils/productionConsole";

disableProductionConsole();

const root = ReactDOM.createRoot(document.getElementById("root"));
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15 * 1000,
      gcTime: 10 * 60 * 1000,
      refetchOnReconnect: "always",
      refetchOnWindowFocus: true,
      retry: (failureCount, error) => {
        const status = error?.response?.status;
        if ([401, 403, 404, 422].includes(status)) return false;
        return failureCount < 3;
      },
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 8000),
    },
  },
});
root.render(
  <>
    <Provider store={store}>
      <I18nextProvider>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter basename="">
            <ThemeContext>
              <App />
            </ThemeContext>
          </BrowserRouter>
        </QueryClientProvider>
      </I18nextProvider>
    </Provider>
  </>
);
reportWebVitals();
